export * from './Title3';
export { title3ClassNames } from './useTitle3Styles.styles';
